export const siteInfo = {
  name: '看料大瓜',
  slogan: '一站式补瓜 · 热点事件合集盘点',
  description:
    '看料大瓜按时间线汇总近期最热门的娱乐话题与精华讨论，帮你在几分钟内补齐事件脉络，吃瓜不掉队。',
  email: 'hello@kanliaodagua.example',
  contactNote: '内容纠错、话题投稿与合作事宜，欢迎通过邮件联系我们，我们会在两个工作日内回复。',
};

export const categories = [
  {
    id: 'variety',
    name: '综艺热度',
    count: 42,
    desc: '综艺节目的模式变化、话题走向与讨论热度追踪。',
    image:
      'https://readdy.ai/api/search-image?query=warm%20abstract%20television%20studio%20stage%20with%20amber%20spotlights%20and%20soft%20haze%2C%20minimal%20editorial%20photography%2C%20warm%20cream%20background%2C%20artistic%20stylized%20composition&width=900&height=700&seq=kldg-cat-variety-01&orientation=landscape',
  },
  {
    id: 'drama',
    name: '剧集观察',
    count: 36,
    desc: '剧集口碑、题材趋势与观众讨论焦点的梳理。',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20cinema%20screen%20glow%20with%20warm%20terracotta%20light%20beams%2C%20minimal%20editorial%20art%20photography%2C%20cream%20toned%20background%2C%20soft%20grain%20texture&width=900&height=700&seq=kldg-cat-drama-02&orientation=landscape',
  },
  {
    id: 'music',
    name: '音乐舞台',
    count: 28,
    desc: '音乐现场、舞台设计与表演呈现的话题盘点。',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20concert%20stage%20silhouette%20with%20warm%20golden%20lights%20and%20drifting%20smoke%2C%20minimal%20artistic%20photography%2C%20warm%20beige%20backdrop%2C%20high%20contrast%20shapes&width=900&height=700&seq=kldg-cat-music-03&orientation=landscape',
  },
  {
    id: 'meme',
    name: '网络热梗',
    count: 51,
    desc: '一周热梗与社交平台讨论点的快速速览。',
    image:
      'https://readdy.ai/api/search-image?query=playful%20abstract%20speech%20bubble%20shapes%20in%20warm%20orange%20and%20crimson%20tones%2C%20minimal%20graphic%20art%2C%20cream%20paper%20background%2C%20clean%20flat%20composition&width=900&height=700&seq=kldg-cat-meme-04&orientation=landscape',
  },
  {
    id: 'style',
    name: '造型红毯',
    count: 23,
    desc: '红毯造型、妆发风格与视觉效果讨论汇总。',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20abstract%20fabric%20drape%20in%20warm%20amber%20and%20rose%20tones%2C%20minimal%20fashion%20editorial%20still%20life%2C%20cream%20background%2C%20soft%20diffused%20light&width=900&height=700&seq=kldg-cat-style-05&orientation=landscape',
  },
];

export const articles = [
  {
    id: 'slow-variety-return',
    title: '慢综艺回潮：这一季观众为什么更愿意看“过日子”',
    category: 'variety',
    categoryName: '综艺热度',
    author: '瓜田观察室',
    date: '2026-09-10',
    readTime: '6 分钟',
    heat: 98,
    tags: ['慢综艺', '节目模式', '观众心理'],
    summary:
      '从竞技对抗到日常陪伴，综艺市场的口味正在发生微妙转向。本篇梳理慢综艺回潮背后的三条线索，并给出补课顺序。',
    highlights: [
      '慢综艺的核心竞争力从“刺激感”转向“陪伴感”',
      '录制场景的日常化降低了观众的进入门槛',
      '话题扩散从正片转移到花絮与二创切片',
    ],
    content: [
      '如果把这几个月的综艺讨论按热度排序，会发现一个有趣的现象：占据话题榜前列的，往往不是赛制最复杂的竞技节目，而是一些节奏松弛、以日常生活为主线的慢综艺。这类节目没有强烈的胜负欲，却意外地留住了观众的注意力。',
      '第一条线索来自观众的心理预期。当大量高强度的竞技内容同时上线，观众会产生一定的审美疲劳。慢综艺提供了一种低门槛的观看方式——不需要记住复杂规则，随时点开都能看懂，这种“随时可进入”的特性，恰好契合了碎片化的观看习惯。',
      '第二条线索是场景的日常化。相比搭建大型舞台，把镜头对准厨房、院子、海边小屋的节目，反而更容易让观众产生代入感。节目讨论的焦点也从“谁赢了”变成了“这段相处很有意思”，话题本身更温和，扩散周期也更长。',
      '第三条线索则发生在正片之外。慢综艺的高光片段天然适合被剪成短切片，在社交平台上二次传播。很多观众是先刷到切片，才回头去看整期节目的。这意味着制作方需要重新思考：正片与切片之间的关系，正在从“节选”变成“导流”。',
      '对普通观众来说，补课这类话题不必从头追到尾。可以先看节目的话题切片建立大致印象，再挑一两期完整正片感受节奏，最后回到讨论区看看大家的观点碰撞，基本就能跟上一轮话题。',
      '需要提醒的是，慢综艺的回潮并不意味着竞技模式失效。更准确的说法是，市场重新意识到了“节奏多样性”的价值。观众需要刺激，也需要松弛，能把两种节奏都做好的平台，才更有可能长期留住用户。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=cozy%20minimal%20countryside%20kitchen%20with%20warm%20afternoon%20light%2C%20soft%20amber%20tones%2C%20editorial%20lifestyle%20photography%2C%20cream%20neutral%20palette%2C%20calm%20composition&width=1200&height=800&seq=kldg-art-slowvariety-11&orientation=landscape',
  },
  {
    id: 'summer-drama-realism',
    title: '夏季档剧集观察：现实题材重回讨论中心的三条线索',
    category: 'drama',
    categoryName: '剧集观察',
    author: '剧集速记',
    date: '2026-09-08',
    readTime: '7 分钟',
    heat: 94,
    tags: ['现实题材', '剧集口碑', '暑期档'],
    summary:
      '这个夏天，现实题材剧集重新成为社交平台的讨论中心。本篇从题材选择、人物塑造与讨论方式三个角度梳理来龙去脉。',
    highlights: [
      '贴近生活的职场与家庭议题更容易引发共鸣',
      '人物弧光的完整度成为口碑分水岭',
      '讨论从剧情本身延伸到社会话题，延长了热度周期',
    ],
    content: [
      '每年暑期档都是剧集市场的集中释放期，今年的讨论重心明显偏向现实题材。与往年不同，今年的热度并不完全由阵容决定，更多观众的注意力放在了故事是否“站得住”上。',
      '从题材选择看，职场、家庭、代际沟通这些与日常生活密切相关的议题，天然具备讨论基础。观众在看剧的同时，会不自觉地代入自己的经历，这种代入感比强设定的类型剧更容易持续发酵。',
      '人物塑造是口碑的分水岭。剧情推进是否合理、角色的选择是否符合其性格逻辑，成为观众争论最激烈的地方。一部剧即便开局口碑不错，只要中后期人物行为变得突兀，讨论风向就会迅速转变。',
      '值得关注的是讨论方式的改变。现在的剧集讨论很少停留在“好不好看”，而是会延伸到相关的社会议题。这种延伸虽然扩大了话题面，但也要求内容本身经得起反复推敲，否则很容易出现解读与剧情脱节的情况。',
      '对想快速补课的读者，建议先看剧集的口碑走向而非单条短评。观察评论是否集中在同几个点上，往往能更快判断这部剧的争议究竟来自哪里。',
      '总体来看，现实题材的回归并不意味着其他类型失去空间，而是说明观众对“真实感”的要求在提高。能在细节上做到可信的作品，无论题材如何，都更容易获得持续关注。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20living%20room%20scene%20with%20soft%20evening%20light%20through%20sheer%20curtains%2C%20muted%20terracotta%20tones%2C%20minimal%20editorial%20photography%2C%20cream%20palette&width=1200&height=800&seq=kldg-art-summerdrama-12&orientation=landscape',
  },
  {
    id: 'music-festival-stage',
    title: '音乐节现场话题盘点：舞台设计与互动环节的三个变化',
    category: 'music',
    categoryName: '音乐舞台',
    author: '现场记录员',
    date: '2026-09-06',
    readTime: '5 分钟',
    heat: 89,
    tags: ['音乐节', '舞台设计', '现场体验'],
    summary:
      '本季音乐节的话题不只是阵容，舞台视觉与现场互动同样成为讨论焦点。本篇盘点三个明显的变化趋势。',
    highlights: [
      '舞台视觉从“堆料”转向“整体叙事”',
      '互动环节更强调观众参与而非单向表演',
      '现场体验与线上讨论形成互相补充的关系',
    ],
    content: [
      '音乐节的讨论热度早就不只取决于阵容名单。今年观众聊得最多的，反而是舞台呈现和现场互动带来的整体感受。这三个变化，值得单独拿出来说说。',
      '第一个变化发生在舞台视觉上。过去大家比的是谁的屏幕更大、灯光更多，现在更受好评的设计往往有清晰的视觉主题。整场演出围绕一个统一的意象展开，观众能记住的是氛围，而不只是某一次爆闪。',
      '第二个变化在互动环节。以往台上的互动偏单向，现在越来越多演出会设计需要全场参与的部分，比如合唱段落、统一的应援节奏。这类设计把观众从“观看者”变成了“参与者”，也更容易产出有传播力的现场片段。',
      '第三个变化是线上线下关系的变化。很多人对音乐节的印象来自网上的现场切片，这些切片反过来又影响了现场体验的期待值。主办方开始意识到，需要同时照顾现场观众的体验和线上观众的观感。',
      '如果你打算去现场，不妨提前看看往届的现场讨论，了解场地动线和互动节奏，会比只看阵容表更有参考价值。',
      '说到底，音乐节的竞争已经从“请到谁”逐步过渡到“如何呈现”。当阵容差异缩小时，整体体验的质量就成了拉开差距的关键。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=open%20air%20music%20festival%20stage%20at%20dusk%20with%20warm%20amber%20stage%20lights%20and%20crowd%20silhouettes%2C%20minimal%20editorial%20photography%2C%20warm%20beige%20and%20orange%20palette&width=1200&height=800&seq=kldg-art-musicfest-13&orientation=landscape',
  },
  {
    id: 'weekly-meme-digest',
    title: '本周网络热梗速览：大家都在讨论什么',
    category: 'meme',
    categoryName: '网络热梗',
    author: '热梗搬运局',
    date: '2026-09-05',
    readTime: '4 分钟',
    heat: 96,
    tags: ['热梗', '社交平台', '速览'],
    summary:
      '一周热梗集中盘点，按话题来源、传播路径和使用场景三栏整理，三分钟看懂本周大家在聊什么。',
    highlights: [
      '热梗的生命周期普遍在一到两周',
      '短视频切片是主要的传播起点',
      '能二次创作的梗更容易出圈',
    ],
    content: [
      '热梗的更新速度远比想象中快。这周还在刷屏的说法，下周可能就少有人提。为了让大家不掉队，我们把本周讨论度较高的几个话题集中整理了一遍。',
      '从来源看，热梗大多起源于某个具体的场景片段——可能是一段对话、一个表情，或者一次意外反应。真正让它扩散的，是这段内容是否便于别人模仿和再加工。可复用性越强，出圈速度越快。',
      '传播路径上，短视频切片几乎成了标配起点。一个梗先在短视频平台完成初步扩散，再被搬到其他平台引发讨论，最后回到内容本身的出处，形成一个闭环。这也解释了为什么很多梗“看得懂但找不到出处”。',
      '从使用场景来说，热梗正在从单纯的玩梗，变成一种社交润滑。用同一个梗表达情绪，能在陌生场合快速建立默契，这也是它能持续流行的原因之一。',
      '想要不被甩在话题之外，其实不必追逐每一个梗。抓住本周讨论度最高的两三个，了解它们的出处和用法，基本就够用了。',
      '最后提醒一句：梗的寿命是有限的。与其纠结学不会，不如把它当作了解当下社交氛围的一扇窗，看得开心就好。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=playful%20abstract%20chat%20bubble%20pattern%20in%20warm%20orange%20and%20deep%20crimson%20tones%20on%20cream%20paper%2C%20flat%20minimal%20graphic%20art%2C%20clean%20composition&width=1200&height=800&seq=kldg-art-meme-14&orientation=landscape',
  },
  {
    id: 'red-carpet-style-trend',
    title: '红毯造型讨论热度上升，造型话题为何长盛不衰',
    category: 'style',
    categoryName: '造型红毯',
    author: '造型笔记',
    date: '2026-09-03',
    readTime: '5 分钟',
    heat: 87,
    tags: ['红毯', '造型', '审美讨论'],
    summary:
      '每逢重要活动，造型讨论总能占据话题前列。本篇拆解造型话题经久不衰的原因，以及如何更有营养地参与讨论。',
    highlights: [
      '造型是最直观、最易参与的话题入口',
      '讨论正在从“好不好看”走向风格分析',
      '配饰与剪裁细节成为新的讨论焦点',
    ],
    content: [
      '活动一结束，造型讨论几乎准时登上话题榜。相比作品本身需要一定背景知识，造型是最直观的话题——看一眼就能形成判断，这也让它天然具备高参与度。',
      '不过讨论的层次正在变化。过去多是简单的“好看”或“不好看”，现在越来越多的讨论会分析色彩搭配、剪裁结构和整体风格是否统一。这种变化说明观众的审美观察在变得细致。',
      '细节成为新的焦点。一件造型的成败，往往不只取决于主色，而是藏在配饰、面料光泽和比例关系里。讨论这些细节，比单纯给造型打分更有信息量。',
      '另一个值得注意的点是，造型讨论的周期通常很短。活动热度过去后，相关话题会迅速降温。所以想在讨论里说出点东西，最好在活动当天就读懂造型的整体思路。',
      '参与造型讨论时，不妨先从“这套造型想表达什么”入手，再看它是否达成了这个目标。这样聊出来的观点，会比单纯评价美丑更有分量。',
      '归根结底，造型话题的持久，是因为它把审美判断权交回给了每一个观众。人人都能参与，人人都能表达，这正是它长盛不衰的底层原因。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=elegant%20fabric%20draping%20detail%20in%20warm%20amber%20and%20rose%20sunset%20tones%2C%20minimal%20fashion%20editorial%20still%20life%2C%20cream%20background%2C%20soft%20directional%20light&width=1200&height=800&seq=kldg-art-redcarpet-15&orientation=landscape',
  },
  {
    id: 'awards-season-preview',
    title: '颁奖季前瞻：哪些作品进入了大众讨论视野',
    category: 'drama',
    categoryName: '剧集观察',
    author: '瓜田观察室',
    date: '2026-09-01',
    readTime: '6 分钟',
    heat: 82,
    tags: ['颁奖季', '作品讨论', '趋势'],
    summary:
      '颁奖季临近，讨论开始升温。本篇从讨论热度、口碑走向与题材分布三个维度，梳理目前进入视野的作品特征。',
    highlights: [
      '讨论热度与最终结果之间并非简单的正相关',
      '口碑的稳定性比一时的峰值更重要',
      '题材分布反映了内容市场的整体取向',
    ],
    content: [
      '每到颁奖季，关于作品的讨论就会明显升温。与其急着预测结果，不如先看清楚目前哪些作品真正进入了大众的讨论视野。',
      '从讨论热度看，热度高并不等于胜算大。很多作品靠单点话题冲上榜单，但持续时间短；而讨论稳定、能够被反复提及的作品，往往走得更远。观察讨论是否集中在同一批作品上，比看某一天的峰值更有参考价值。',
      '口碑的稳定性是另一个关键指标。开分高但中后期争议不断的作品，通常在长跑中不占优势。真正被看好的，是那些从头到尾都保持相对一致评价的内容。',
      '题材分布也值得留意。当某一类题材集中出现在讨论中，往往是整个内容市场取向的缩影。这不只是奖项问题，也反映了观众一段时间内的关注重点。',
      '如果你是抱着补课的心态，可以先挑两三部讨论最集中的作品看看简介和观点分歧点，再决定要不要深入，比盲目追全片效率高得多。',
      '需要强调的是，颁奖季的讨论魅力恰恰在于不确定。保持开放心态看待不同观点，比早早站队更能享受这个过程。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20trophy%20silhouette%20with%20warm%20golden%20amber%20light%20rays%2C%20minimal%20editorial%20art%20photography%2C%20cream%20and%20terracotta%20palette%2C%20elegant%20simple%20composition&width=1200&height=800&seq=kldg-art-awards-16&orientation=landscape',
  },
  {
    id: 'reality-show-format',
    title: '竞技综艺赛制迭代：从“剧本感”到“真实感”的转向',
    category: 'variety',
    categoryName: '综艺热度',
    author: '节目观察组',
    date: '2026-08-29',
    readTime: '6 分钟',
    heat: 79,
    tags: ['竞技综艺', '赛制', '真实感'],
    summary:
      '竞技综艺的赛制设计正在经历一轮调整。本篇梳理赛制迭代的方向，以及观众对“真实感”诉求的变化。',
    highlights: [
      '过度设计反而削弱了观看体验',
      '观众更在意规则的公平与透明',
      '真实反应的片段更易被反复传播',
    ],
    content: [
      '竞技综艺一度以复杂赛制取胜，规则越绕、反转越多，越能制造话题。但最近的讨论风向在变，观众开始对“设计感过强”的环节表现出疲态。',
      '一个明显的变化是，观众越来越在意规则本身是否公平透明。当赛制被质疑存在明显倾斜时，讨论会迅速从节目内容转向规则本身，这对节目口碑的伤害往往更大。',
      '另一个变化是真实反应的价值被重新认识。意料之外的瞬间、真实的情绪流露，比起精心设计的桥段更能打动人，也更容易被剪成切片反复传播。',
      '这种转向并不意味赛制不再重要，而是设计要求更高了：好的赛制应该激发真实的反应，而不是预设好结果再往里填内容。这两者的差别，观众一眼就能看出来。',
      '看这类节目时，可以留意一下规则说明是否清晰、淘汰机制是否合理。这些细节往往决定了节目后半程的观感。',
      '总的来说，竞技综艺正在从“比谁更会设计”回到“比谁更真诚”。这个转向对观众而言，无疑是件好事。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20stage%20arena%20with%20warm%20amber%20spotlight%20beams%20and%20geometric%20shapes%2C%20minimal%20editorial%20photography%2C%20cream%20and%20orange%20palette%2C%20clean%20composition&width=1200&height=800&seq=kldg-art-realityshow-17&orientation=landscape',
  },
  {
    id: 'behind-scenes-vlog',
    title: '幕后花絮为何越来越受欢迎：观众想看的是什么',
    category: 'variety',
    categoryName: '综艺热度',
    author: '现场记录员',
    date: '2026-08-27',
    readTime: '5 分钟',
    heat: 75,
    tags: ['幕后花絮', '内容生态', '观看动机'],
    summary:
      '正片之外，幕后花絮正在成为独立的内容品类。本篇分析花絮内容走红的原因和观看动机。',
    highlights: [
      '花絮满足了观众对“真实状态”的好奇',
      '制作过程本身也是一种内容',
      '花絮与正片形成互相补充的关系',
    ],
    content: [
      '过去幕后花絮只是正片的附加内容，如今它已经能独立撑起一波讨论。这种变化背后，是观众观看动机的转移。',
      '看花絮的乐趣，很大程度上来自“看到真实状态”。正片里的表现经过剪辑与设计，而花絮记录的是间隙里的自然反应，这种不设防的瞬间更容易让人产生亲近感。',
      '制作过程本身也成了看点。从场景搭建到现场调度，观众开始对内容如何被生产出来产生兴趣。这让花絮不再是边角料，而是一种独立的信息型内容。',
      '花絮与正片之间形成了互补。正片负责叙事和情绪，花絮负责补充背景和细节。看完正片再刷花絮，往往能获得更完整的理解。',
      '如果你想更全面地了解一个节目，建议是：正片为主，花絮为辅。按这个顺序看，信息接收的效率会更高。',
      '可以预见，花絮的内容化程度还会继续提高。对观众来说，这意味着一档节目能提供的信息量变大了，但同时也需要学会筛选，避免被零碎内容牵着走。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20minimal%20studio%20with%20warm%20lighting%20stands%20and%20soft%20haze%2C%20editorial%20documentary%20style%2C%20cream%20and%20amber%20palette%2C%20clean%20composition&width=1200&height=800&seq=kldg-art-bts-18&orientation=landscape',
  },
  {
    id: 'idol-stage-growth',
    title: '舞台直拍走红之后：实力讨论正在取代流量话题',
    category: 'music',
    categoryName: '音乐舞台',
    author: '舞台观察者',
    date: '2026-08-25',
    readTime: '5 分钟',
    heat: 77,
    tags: ['舞台直拍', '实力讨论', '内容评价'],
    summary:
      '舞台直拍的流行改变了讨论的焦点。本篇分析直拍内容如何推动评价标准从流量转向实力。',
    highlights: [
      '直拍让舞台表现成为可拆解的评价对象',
      '观众的关注点转向完成度与细节',
      '评价标准的透明化提升了讨论质量',
    ],
    content: [
      '舞台直拍最初只是演出内容的补充素材，如今却成了讨论舞台表现的主要依据。一场演出之后，围绕直拍的讨论往往比正片更热烈。',
      '直拍的价值在于它把舞台表现变成了可拆解的对象。唱跳的完成度、动作的力度、表情的管理，这些细节在直拍里都一目了然，观众的判断也有了更具体的依据。',
      '随之而来的是评价标准的转移。相比过往更多关注人气和话题度，现在讨论更常围绕“这个舞台完成得怎么样”展开。这种转向让评价更接近内容本身。',
      '当然，直拍也带来了新的问题：片段化的观看容易让人只关注某一个瞬间，忽略整场演出的整体设计。所以看直拍时，最好也配合完整舞台一起看。',
      '想认真评价一个舞台，可以先看直拍观察细节，再看完整版本理解整体编排，两者结合，判断会更全面。',
      '从长远看，直拍推动的评价透明化，对内容质量的提升是有正向作用的。当努力可以被清晰看见，讨论自然会更聚焦在作品上。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=abstract%20stage%20performance%20silhouette%20with%20warm%20amber%20backlight%20and%20floating%20dust%20particles%2C%20minimal%20editorial%20photography%2C%20cream%20and%20orange%20palette&width=1200&height=800&seq=kldg-art-idolstage-19&orientation=landscape',
  },
];

export const timeline = [
  { date: '09月10日', title: '慢综艺回潮引发讨论', category: '综艺热度', articleId: 'slow-variety-return' },
  { date: '09月08日', title: '现实题材剧集重回话题中心', category: '剧集观察', articleId: 'summer-drama-realism' },
  { date: '09月06日', title: '音乐节舞台设计成讨论焦点', category: '音乐舞台', articleId: 'music-festival-stage' },
  { date: '09月05日', title: '本周热梗集中盘点', category: '网络热梗', articleId: 'weekly-meme-digest' },
  { date: '09月03日', title: '红毯造型话题持续升温', category: '造型红毯', articleId: 'red-carpet-style-trend' },
  { date: '09月01日', title: '颁奖季前瞻讨论开启', category: '剧集观察', articleId: 'awards-season-preview' },
];

export const faqs = [
  {
    q: '看料大瓜主要汇总哪一类内容？',
    a: '我们专注娱乐行业的热点话题盘点，涵盖综艺、剧集、音乐舞台、网络热梗与造型红毯等方向，按时间线整理事件脉络，帮助你快速补课。',
  },
  {
    q: '网站上的内容多久更新一次？',
    a: '热度榜与时间线通常每周更新一次，重点话题会随时补充。遇到集中的热点周期，我们会加更，确保脉络完整。',
  },
  {
    q: '为什么有些话题只有要点速览，没有长篇正文？',
    a: '部分话题本身信息量有限，长篇展开反而会稀释重点。我们会用要点速览的形式呈现，把篇幅留给信息密度更高的内容。',
  },
  {
    q: '网站内容的立场是什么？',
    a: '我们只做话题梳理与现象观察，不进行人身评价，也不传播未经证实的说法。遇到存在争议的信息，我们会明确标注讨论焦点，把判断权交回给你。',
  },
  {
    q: '可以投稿或者指出内容错误吗？',
    a: '当然可以。欢迎通过页脚的邮箱联系我们，注明具体话题和问题点。我们会核对后尽快修订，并在页面上更新。',
  },
  {
    q: '如何更高效地使用本站？',
    a: '建议先看首页热度榜建立整体印象，再进入话题合集页按分类筛选。对感兴趣的选题，点进详情页看要点速览，几分钟就能掌握来龙去脉。',
  },
];

export const siteStats = [
  { value: '180+', label: '已整理话题合集' },
  { value: '5', label: '内容分类方向' },
  { value: '每周', label: '热度榜单更新' },
  { value: '3 分钟', label: '平均补课时长' },
];

export const testimonials = [
  {
    name: '小满',
    role: '追综三年',
    quote:
      '以前补课要翻好几个平台，现在直接看时间线就理清楚了。要点速览这段特别实用，碎片时间也能跟上进度。',
  },
  {
    name: '阿栗',
    role: '通勤党',
    quote: '地铁上刷两篇就够聊一周了。最舒服的是它不做人身评价，只讲事情怎么发生的，看着不累。',
  },
  {
    name: '老周',
    role: '内容从业者',
    quote: '分类很清晰，想研究某个方向的变化趋势时，按分类翻一遍就能看到脉络，省了我不少整理时间。',
  },
];